import 'babel-polyfill' 
import Vue from 'vue'
import App from './App'
import router from './router'
import fastclick from 'fastclick'
import './common/css/border.css'
import './common/css/reset.css'
import './common/css/iconfont.css'
import axios from 'axios'

fastclick.attach(document.body);

Vue.config.productionTip = false

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

Vue.prototype.$axios=axios


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js